import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

const HighchartsReact = dynamic(() => import("highcharts-react-official"), {
  ssr: false,
});

export default function Sectors({ data, locked }) {
  const [Highcharts, setHighcharts] = useState(null);

  useEffect(() => {
    import("highcharts").then((module) => {
      setHighcharts(module.default);
    });
  }, []);

  const options = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    title: false,
    xAxis: {
      categories: data.map((item) => item.year),
      labels: {
        style: {
          color: "#FFFFFF", // Changed to solid white
        },
      },
    },
    yAxis: {
      gridLineWidth: 0,
      title: {
        text: "Amount of Investments",
      },
      labels: {
        style: {
          color: "#FFFFFF", // Changed to solid white
        },
      },
    },
    plotOptions: {
      series: {
        color: "#EB760A",
        borderWidth: 0,
        dataLabels: {
          enabled: !locked,
          style: {
            color: "#fff",
            textOutline: "none",
            fontSize: "15px",
          },
        },
      },
    },
    series: [
      {
        data: data.map((item) => item.value),
      },
    ],
  };

  if (!Highcharts) {
    return <div>Loading chart...</div>;
  }

  return (
    <div>
      <HighchartsReact
        locked={locked}
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
}
